import { Component, Inject } from '@angular/core';
import { BaseComponent } from './base.component';
import { Observable, take } from 'rxjs';
import { remove } from 'lodash-es';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    template: ``,
    standalone: false
})
export abstract class TableLikeBaseComponent<TTableModel extends RowLikeEntity> extends BaseComponent {
	public dataSource$: Observable<MatTableDataSource<TTableModel>>;
	public selectedIds = [];
	protected itemPrimaryKey: keyof TTableModel;

	protected constructor(@Inject(Object) params?: Params<TTableModel>) {
		super();
		this.itemPrimaryKey = params?.itemPrimaryKey ?? 'id';
	}

	public selectAll(isChecked: boolean): void {
		if (!isChecked) {
			this.selectedIds = [];
			return;
		}

		this.dataSource$.pipe(take(1)).subscribe((source) => {
			this.selectedIds = source.data.map((item) => item[this.itemPrimaryKey]);
		});
	}

	public isSelected(item: Record<keyof TTableModel, any>): boolean {
		const keyValue: string = item[this.itemPrimaryKey];
		return this.selectedIds.includes(keyValue);
	}

	public toggleSelected(item: Record<keyof TTableModel, any>): void {
		const keyValue: string = item[this.itemPrimaryKey];
		if (this.isSelected(item)) {
			remove(this.selectedIds, (selectedId) => selectedId === keyValue);
		} else {
			this.selectedIds.push(keyValue);
		}
	}
}

interface RowLikeEntity {
	id: string;
}

interface Params<T> {
	itemPrimaryKey?: keyof T;
}
